import React from 'react';
import { BODY_REGIONS, REGION_LABEL } from '../utils/bodyRegions.js';

// "Tap where it hurts" body map. value = array of region keys (or a
// comma-separated string); onChange gets the updated array.
export default function BodyMapInput({ value = [], onChange, readOnly = false }) {
  const selected = Array.isArray(value)
    ? value
    : String(value || '').split(',').filter(Boolean);

  const toggle = (key) => {
    if (readOnly || !onChange) return;
    onChange(selected.includes(key) ? selected.filter(k => k !== key) : [...selected, key]);
  };

  return (
    <div style={{ display: 'flex', gap: 14, alignItems: 'flex-start', flexWrap: 'wrap' }}>
      <svg viewBox="0 0 100 210" style={{ width: 128, height: 269, flexShrink: 0, touchAction: 'manipulation' }}>
        <g fill="#e2e8f0" stroke="#cbd5e1" strokeWidth="0.5">
          <circle cx="50" cy="12" r="8" />
          <rect x="45" y="19" width="10" height="6" rx="2" />
          <rect x="34" y="25" width="32" height="44" rx="8" />
          <rect x="40" y="67" width="20" height="42" rx="6" />
          <rect x="23" y="29" width="9" height="54" rx="4" />
          <rect x="68" y="29" width="9" height="54" rx="4" />
          <rect x="40" y="105" width="9" height="86" rx="4" />
          <rect x="51" y="105" width="9" height="86" rx="4" />
        </g>
        {BODY_REGIONS.map(r => {
          const on = selected.includes(r.key);
          return (
            <g key={r.key} onClick={() => toggle(r.key)} style={{ cursor: readOnly ? 'default' : 'pointer' }}>
              {/* larger invisible hit target for little fingers */}
              <circle cx={r.x} cy={r.y} r="7" fill="transparent" />
              <circle cx={r.x} cy={r.y} r="5"
                fill={on ? '#ef4444' : 'rgba(255,255,255,0.9)'}
                stroke={on ? '#b91c1c' : '#94a3b8'} strokeWidth="1" />
              {on && <circle cx={r.x} cy={r.y} r="2" fill="#fff" />}
            </g>
          );
        })}
      </svg>

      <div style={{ fontSize: '0.85rem', minWidth: 130 }}>
        <div style={{ color: '#64748b', marginBottom: 6 }}>
          {readOnly ? 'Reported sore:' : 'Tap where it hurts'}
        </div>
        {selected.length === 0 ? (
          <div style={{ color: '#94a3b8' }}>{readOnly ? 'Nothing reported' : 'Nothing selected'}</div>
        ) : (
          selected.map(k => (
            <span key={k} onClick={() => toggle(k)}
              style={{
                display: 'inline-block', margin: '2px 4px 2px 0', padding: '2px 8px',
                borderRadius: 999, background: '#fee2e2', color: '#991b1b',
                cursor: readOnly ? 'default' : 'pointer', fontSize: '0.8rem',
              }}>
              {REGION_LABEL[k] || k}{!readOnly && ' ✕'}
            </span>
          ))
        )}
      </div>
    </div>
  );
}
